var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"container"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":18,"width":18}}),_c('span',[_vm._v("加载更多内容")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }